import React from "react";
import { HXCircleIcon, OnboardDueDateCard } from "@aph/ui-lib-humanx";
import PeriodDate from "@/components/PageHome/components/OnboardingSection/Modals/PeriodDate";
import PeriodCycle from "@/components/PageHome/components/OnboardingSection/Modals/PeriodCycle";
import DueDate from "@/components/PageHome/components/OnboardingSection/Modals/DueDate";
import BirthDate from "@/components/PageHome/components/OnboardingSection/Modals/BirthDate";
import styles from "@/components/PageHome/components/OnboardingSection/Flows/Flows.module.scss";

export interface FlowProps {
  isModalOpen: boolean;
  setIsModalOpen?: (status: boolean) => void;
  dueDate?: Date;
  birthDate?: Date;
}

const PREGNANCY_PERIOD_LIMITS = [289, -10];

const ICON_STYLE = { style1: "style1", style2: "style2", style3: "style3", style4: "style4" };

const MODAL_KEYS = {
  type: "type",
  heading: "heading",
  description: "description",
  ctaText: "ctaText",
  btnClick: "btnClick",
  onClose: "onClose",
  ctaBelowText: "ctaBelowText",
  middleSection: "middleSection",
  bgIcon: "bgIcon",
  initialDate: "initialDate",
  periodLimits: "periodLimits",
};

const MODAL_TYPES = {
  periodDate: "periodDate",
  periodCycle: "periodCycle",
  dueDate: "dueDate",
  birthDate: "birthDate",
};

const renderModalContent = (currentModalData: any): React.ReactElement => {
  const type = currentModalData[MODAL_KEYS.type];

  const bgIcon = currentModalData[MODAL_KEYS.bgIcon] && (
    <HXCircleIcon
      iconStyle={currentModalData[MODAL_KEYS.bgIcon].iconStyle}
      className={styles[currentModalData[MODAL_KEYS.bgIcon].className]}
    />
  );

  switch (type) {
    case MODAL_TYPES.periodDate:
      return (
        <PeriodDate
          dateLimits={currentModalData[MODAL_KEYS.periodLimits]}
          initialDate={currentModalData[MODAL_KEYS.initialDate]}
          heading={currentModalData[MODAL_KEYS.heading]}
          description={currentModalData[MODAL_KEYS.description]}
          bgIcon={bgIcon}
          ctaText={currentModalData[MODAL_KEYS.ctaText]}
          ctaClick={currentModalData?.btnClick}
          ctaBelowText={currentModalData?.ctaBelowText}
        />
      );
    case MODAL_TYPES.periodCycle:
      return (
        <PeriodCycle
          heading={currentModalData[MODAL_KEYS.heading]}
          description={currentModalData[MODAL_KEYS.description]}
          bgIcon={bgIcon}
          ctaText={currentModalData[MODAL_KEYS.ctaText]}
          ctaClick={currentModalData?.btnClick}
          ctaBelowText={currentModalData?.ctaBelowText}
        />
      );
    case MODAL_TYPES.dueDate:
      return (
        <DueDate
          initialDate={currentModalData[MODAL_KEYS.initialDate]}
          heading={currentModalData[MODAL_KEYS.heading]}
          description={currentModalData[MODAL_KEYS.description]}
          bgIcon={bgIcon}
          ctaText={currentModalData[MODAL_KEYS.ctaText]}
          ctaClick={currentModalData?.btnClick}
          ctaBelowText={currentModalData?.ctaBelowText}
        />
      );
    case MODAL_TYPES.birthDate:
      return (
        <BirthDate
          initialDate={currentModalData[MODAL_KEYS.initialDate]}
          heading={currentModalData[MODAL_KEYS.heading]}
          description={currentModalData[MODAL_KEYS.description]}
          bgIcon={bgIcon}
          ctaText={currentModalData[MODAL_KEYS.ctaText]}
          ctaClick={currentModalData?.btnClick}
          ctaBelowText={currentModalData?.ctaBelowText}
        />
      );
    default:
      return (
        <OnboardDueDateCard
          titleText={currentModalData[MODAL_KEYS.heading]}
          subTitleText={currentModalData[MODAL_KEYS.description]}
          backgroundCard={bgIcon}
          middleSection={currentModalData[MODAL_KEYS.middleSection]}
          ctaText={currentModalData[MODAL_KEYS.ctaText]}
          ctaClick={currentModalData?.btnClick}
          ctaBelowText={currentModalData?.ctaBelowText}
        />
      );
  }
};

export { ICON_STYLE, MODAL_KEYS, MODAL_TYPES, renderModalContent, PREGNANCY_PERIOD_LIMITS };
